<main class="gestor">

  <header class="gestor__cabecalho">
    <h1 class="gestor__titulo">
      <i class="fas fa-rocket" aria-hidden="true"></i>
      Implantação assistida
    </h1>
    <p class="gestor__linha-fina">
      <ng-container *ngIf="estado">contato {{ estado.waId }} · {{ rotuloDaFase(fase) }}</ng-container>
      <ng-container *ngIf="estado?.atendimentoId"> · atendimento #{{ estado.atendimentoId }}</ng-container>
      <ng-container *ngIf="conversa.onboardingId"> · implantação #{{ conversa.onboardingId }}</ng-container>
      <ng-container *ngIf="conversa.empresaId"> · empresa #{{ conversa.empresaId }}</ng-container>
      <ng-container *ngIf="!estado && carregando">abrindo o canal…</ng-container>
    </p>
    <a class="gestor__simulador" routerLink="/admin/mia-gestor/comercial">Atendimento comercial</a>
    <a class="gestor__simulador" routerLink="/admin/mia-gestor/numeros">Número da Mia</a>
    <a class="gestor__simulador" routerLink="/admin/mia-gestor/leads">Leads</a>
    <a class="gestor__simulador" routerLink="/admin/mia-gestor/implantacao"
       title="Painel antigo, ligado direto à implantação do admin logado (sem a conversa comercial)">Painel antigo</a>
    <button type="button" class="gestor__simulador" [class.gestor__simulador--real]="!naoExecutarAcoes"
            (click)="naoExecutarAcoes = !naoExecutarAcoes"
            title="Travado, a confirmação do teste por botão ou texto e as aprovações não executam (a Mia avisa no chat). Destravado, é idêntico ao WhatsApp: cria usuário, loja e manda e-mail">
      <i class="fas" [class.fa-lock]="naoExecutarAcoes" [class.fa-lock-open]="!naoExecutarAcoes" aria-hidden="true"></i>
      {{ naoExecutarAcoes ? 'Não executar ações' : 'Ações executam de verdade' }}
    </button>
  </header>

  <!-- faixa de progresso: informa, não navega -->
  <ol class="progresso" aria-label="Progresso da implantação">
    <li *ngFor="let passo of passos; trackBy: chaveDoPasso" class="progresso__passo" [ngClass]="'progresso__passo--' + passo.estado">
      <span class="progresso__marca" aria-hidden="true"></span>
      <span class="progresso__texto">
        <strong>{{ passo.rotulo }}</strong>
        <small>{{ passo.detalhe }}</small>
      </span>
    </li>
  </ol>

  <div class="gestor__aviso gestor__aviso--erro" *ngIf="erro">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <span>{{ erro }}</span>
  </div>

  <div class="gestor__aviso" *ngIf="!naoExecutarAcoes">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <span>
      <strong>A trava está desligada.</strong>
      Confirmar por texto ou tocar em "Criar meu teste" cria usuário, loja e envia o e-mail de acesso; as aprovações criam empresa e importam produto — tudo de verdade, como no WhatsApp.
    </span>
  </div>

  <div class="gestor__aviso" *ngIf="!conversa.verificandoAgente && !conversa.agenteDisponivel">
    <i class="fas fa-plug" aria-hidden="true"></i>
    <span><strong>A Mia está fora do ar.</strong> O canal continua aceitando mensagens, mas ninguém responde.</span>
    <button type="button" (click)="conversa.verifiqueAgente()">Tentar de novo</button>
  </div>

  <!-- corpo: a conversa manda na tela; a lateral só informa o estado -->
  <div class="gestor__corpo">
  <div class="gestor__conversa">

  <section class="janela">
    <header class="janela__topo">
      <span class="janela__contato">
        <span class="janela__avatar" aria-hidden="true"><i class="fas fa-headset"></i></span>
        <span class="janela__quem">
          <strong>MIA Gestor</strong>
          <small>
            <ng-container *ngIf="carregando">abrindo o canal…</ng-container>
            <ng-container *ngIf="!carregando">{{ conversa.etapaLegivel }}</ng-container>
          </small>
        </span>
      </span>
      <span class="janela__estado"
            [class.janela__estado--fora]="!conversa.verificandoAgente && !conversa.agenteDisponivel">
        {{ conversa.verificandoAgente ? 'verificando' : conversa.agenteDisponivel ? 'online' : 'fora do ar' }}
      </span>

      <button type="button" class="janela__reiniciar conversa__copiar" (click)="copieConversa()"
              [disabled]="!mensagens.length || carregando || copiando"
              title="Copiar as mensagens, opções e links da conversa">
        <i class="fas fa-copy" aria-hidden="true"></i> {{ copiando ? 'Copiando…' : 'Copiar conversa' }}
      </button>

      <button type="button" class="janela__reiniciar" *ngIf="!confirmandoReinicio"
              [disabled]="!estado || reiniciando || enviando"
              title="Troca o contato fictício: a próxima mensagem chega como um desconhecido, em INICIO"
              (click)="confirmandoReinicio = true">
        <i class="fas fa-redo-alt" aria-hidden="true"></i> Começar do zero
      </button>

      <span class="janela__confirma" *ngIf="confirmandoReinicio">
        <small>Abandona este contato e começa outro. Loja e teste já criados continuam existindo.</small>
        <button type="button" (click)="confirmandoReinicio = false">Voltar</button>
        <button type="button" class="janela__confirma--sim" [disabled]="reiniciando" (click)="reinicie()">
          {{ reiniciando ? 'Começando…' : 'Começar do zero' }}
        </button>
      </span>
    </header>

    <p class="escrita__dica" role="status" *ngIf="avisoCopia">{{ avisoCopia }}</p>

    <div #corpoChat class="conversa" aria-live="polite">

      <div class="conversa__esqueleto" *ngIf="carregando">
        <span></span><span></span><span></span>
      </div>

      <p class="conversa__vazia" *ngIf="!mensagens.length && !carregando">
        Você é um contato desconhecido chegando no WhatsApp da Mia — mande um oi que ela se apresenta.
      </p>

      <!-- só o que passou pelo transporte simulado, com os cortes da Cloud -->
      <ng-container *ngFor="let item of mensagens">
        <p class="nota" *ngIf="item.papel === 'nota'">{{ item.texto }}
            <button type="button" class="mensagem__copiar" (click)="copieMensagem(item)"
                    [disabled]="copiando" title="Copiar mensagem" aria-label="Copiar mensagem">
              <i class="fas fa-copy" aria-hidden="true"></i> Copiar
            </button>
        </p>

        <div class="fala" *ngIf="item.papel !== 'nota'" [class.fala--minha]="item.papel === 'usuario'">
          <div class="balao">
            <p class="balao__texto">
              <ng-container *ngFor="let trecho of partesDaMensagem(item.texto)">
                <a class="balao__link" *ngIf="trecho.link" [href]="trecho.link"
                   target="_blank" rel="noopener noreferrer">{{ trecho.texto }}</a>
                <strong *ngIf="trecho.destaque && !trecho.link">{{ trecho.texto }}</strong>
                <ng-container *ngIf="!trecho.destaque && !trecho.link">{{ trecho.texto }}</ng-container>
              </ng-container>
            </p>

            <button type="button" class="mensagem__copiar" (click)="copieMensagem(item)"
                    [disabled]="copiando" title="Copiar mensagem" aria-label="Copiar mensagem">
              <i class="fas fa-copy" aria-hidden="true"></i> Copiar
            </button>

            <span class="balao__hora">{{ item.criadoEm | date:'HH:mm' }}</span>

            <!-- reply buttons: tocar manda o id do botão, como o button_reply da Cloud -->
            <div class="opcao__linha" *ngFor="let botao of item.botoes">
              <button type="button" class="balao__botao"
                      [disabled]="enviando" [title]="botao.id" (click)="toque(botao)">
                {{ rotuloDeBotao(botao.titulo) }}
              </button>
              <button type="button" class="mensagem__copiar" (click)="copieOpcao(botao.titulo)"
                      [disabled]="copiando" [title]="'Copiar opção: ' + botao.titulo"
                      [attr.aria-label]="'Copiar opção: ' + botao.titulo">
                <i class="fas fa-copy" aria-hidden="true"></i> Copiar
              </button>
            </div>

            <!-- cta_url: abre o endereço, como o botão de link do WhatsApp -->
            <a class="balao__botao balao__botao--link" *ngIf="item.link"
               [href]="item.link.url" target="_blank" rel="noopener noreferrer">
              <i class="fas fa-external-link-alt" aria-hidden="true"></i>
              {{ rotuloDeBotao(item.link.rotulo) }}
            </a>

            <!-- list message: no celular abre uma folha; aqui também -->
            <button type="button" class="balao__botao" *ngIf="item.lista" (click)="abraFolha(item.lista)">
              <i class="fas fa-list-ul" aria-hidden="true"></i>
              {{ rotuloDeBotao(item.lista.rotulo) }}
            </button>
          </div>
        </div>
      </ng-container>

      <div class="fala" *ngIf="enviando">
        <div class="balao balao--digitando"><span></span><span></span><span></span></div>
      </div>
    </div>

    <div class="escrita">
      <button type="button" class="escrita__anexo" disabled
              title="PDF e fotos pelo canal simulado entram na próxima fatia; por enquanto, texto e botões">
        <i class="fas fa-plus" aria-hidden="true"></i>
      </button>
      <textarea #campoMensagem
                name="mensagemCanal"
                rows="1"
                maxlength="4000"
                [(ngModel)]="texto"
                (keydown)="aoTeclar($event)"
                placeholder="Escreva para a Mia…"
                [disabled]="enviando || carregando || !estado"></textarea>
      <button type="button" class="escrita__enviar" (click)="envie()"
              [disabled]="!texto.trim() || enviando || carregando || !estado">
        <i class="fas fa-paper-plane" aria-hidden="true"></i>
      </button>
    </div>
  </section>
  <p class="escrita__dica"><kbd>Enter</kbd> envia · <kbd>Shift + Enter</kbd> quebra a linha</p>

  </div>
  <app-estado-gestor></app-estado-gestor>
  </div>

  <!-- folha da lista: escolher manda o id do item, como o list_reply -->
  <div class="folha" *ngIf="folha as lista">
    <div class="folha__fundo" (click)="fecheFolha()"></div>
    <div class="folha__painel">
      <header>
        <strong>{{ lista.rotulo }}</strong>
        <button type="button" (click)="fecheFolha()" title="Fechar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>
      <ul class="folha__itens">
        <li *ngFor="let item of lista.itens" (click)="escolhaDaLista(item)" role="button" tabindex="0">
          <b>{{ item.titulo }}</b>
          <small>{{ item.descricao }}</small>
        </li>
      </ul>
    </div>
  </div>
</main>
